import React from "react";
import { Form, Input, Button } from "antd";

function DynamicList({ name, label, placeholder }) {
  return (
    <Form.Item label={label}>
      <Form.List name={name}>
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, ...field }) => (
              <div
                key={key}
                style={{ display: "flex", gap: 8, marginBottom: 8 }}
              >
                <Form.Item {...field} noStyle>
                  <Input placeholder={placeholder} style={{ flex: 1 }} />
                </Form.Item>
                <Button danger onClick={() => remove(field.name)}>
                  —
                </Button>
              </div>
            ))}
            <Button type="dashed" onClick={() => add()} block>
              + Нэмэх
            </Button>
          </>
        )}
      </Form.List>
    </Form.Item>
  );
}

export default function OverviewSection() {
  return (
    <>
      <DynamicList
        name="keyFacts"
        label="Үндсэн мэдээлэл"
        placeholder="Жишээ: 24 цагийн дуудлагын үйлчилгээ"
      />
      <DynamicList
        name="pros"
        label="Давуу тал"
        placeholder="Жишээ: Даатгалын хураамжийг 6 хүртэл сард хуваан төлж болно"
      />
      <DynamicList
        name="cons"
        label="Сул тал"
        placeholder="Жишээ: Зах зээлийн үнээр үнэлгээ тогтооно"
      />
    </>
  );
}
